import * as angular from 'angular';
import * as _ from 'lodash';

import template from './ccc.tpl.html';
import {
  LineCounts
} from "../../models/counts/lineCounts";
import { Plant } from "../../models/navigation";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsEnums } from "../../shared/dto/aps.enums";
import { States } from "../../shared/config/constant.module";
import { apsDisplayEnums } from "../../shared/dto/enums";
import { StateParams } from "../../common";
import CountsServiceName, { CountHub, CountsService } from "../../services/counts/counts.service";
import UIUtilityServiceName, { EnumOption, UIUtilityService } from "../../services/utility/uiUtility.service";
import LineConfigsServiceName from "../../services/lineConfigs/lineConfigs.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import GroupRejectsServiceName from "../../services/counts/groupRejects.service";
import { CavityCorrelationReportParams } from "../reports/cavityCorrelationReport.controller";
import EquipmentRejectsName from "./equipmentRejects.controller";
import { IInterval, Interval } from '../../directives/interval.factory';
import { IReportDate, ICountArea, mapModelToAreas, getReportDate } from "../../shared/mapping.functions";
import { IBtn, IBtnArrayOptions } from '../dashboard/btnarray.interfaces';

import IPromise = angular.IPromise;
import IQService = angular.IQService;
import IStateService = angular.ui.IStateService;
import IScope = angular.IScope;
import ShopNavigation = apsViewModels.ShopNavigation;
import CavityCountSummary = apsViewModels.CavityCountSummary;

const requires = [CountsServiceName, UIUtilityServiceName, LineConfigsServiceName, LoaderServiceName,
  NavigationServiceName, AuthDataServiceName, GroupRejectsServiceName, EquipmentRejectsName];

function countsConfig($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.COUNTS_CAVITY_CORRELATION,
    url: '/CountsCavityCorrelation',
    controller: 'CountsCavityCorrelationCtrl as vm',
    template: template,
    data: {
      pageTitle: 'Counts Cavity Correlation', v2Uri: 'aps/dashboard/operator/cavity-correlation'
    }
  });
}

class CountsCavityCorrelationCtrl {
  $scope: IScope;
  $stateParams: StateParams;
  $state: IStateService;
  $interval: angular.IIntervalService;
  $q: IQService;

  authDataService: AuthDataService;
  loading: boolean = false;
  userId: string = null;
  shopId: string = null;
  interval: IInterval = null;
  model: LineCounts = null;
  areas: ICountArea[] = [];
  plant: Plant = null;
  shop: ShopNavigation = null;
  hub: CountHub = null;

  countDisplayIntervalOptions: EnumOption[] = null;
  countsInterval: apsDisplayEnums.CountDisplayInterval;

  canDisableLine = false;
  cavities: CavityCountSummary[] = [];
  hasCavities = false;

  countsService: CountsService;
  loaderService: LoaderService;
  reportDate: IReportDate;
  navigationService: NavigationService;
  navigationUrls: IBtnArrayOptions = {
    buttons: [
      { 'name': 'Horizontal Counts', 'value': 'horizontal', 'selected': false },
      { 'name': 'Vertical Counts', 'value': 'vertical', 'selected': false },
      { 'name': 'Vertical Counts (v2)', 'value': 'vc2', 'selected': false },
    ],
    select: (button: IBtn) => {
      let stateParams = {
        plantId: this.$stateParams.plantId,
        shopId: this.$stateParams.shopId,
        userId: this.$stateParams.userId,
      };

      switch (button.value) {
        case "horizontal": this.$state.go(States.COUNTS_HORIZONTAL, stateParams); break;
        case "vertical": this.$state.go(States.COUNTS_VERTICAL, stateParams); break;
        case "vc2": this.$state.go(States.COUNTS_VERTICAL_V2, stateParams); break;
      }
    }
  };

  barClick: (summary: apsViewModels.CavityCountSummary) => void;

  countsIntervalChanged(): void {
    this.authDataService.setCountInterval(this.countsInterval);
    this.update();
  }

  plantShopsPromise(): IPromise<void> {
    return this.navigationService.getNavigation().then(navModel => {
      this.plant = navModel.selectedPlant;
      this.shop = navModel.selectedShop;
    });
  }

  countsPromise(): IPromise<void> {
    return this.countsService.getLineCounts(
      this.shop.id,
      this.plant,
      this.countsInterval,
      this.canDisableLine)
      .then(result => {
        this.model = result;
        this.areas = mapModelToAreas(this.model);
        for (const id in this.model.equipment) {
          if (this.model.equipment[id].type === apsEnums.LineEquipmentType.HEYE
            || this.model.equipment[id].type === apsEnums.LineEquipmentType.CheckDetector
            || this.model.equipment[id].type === apsEnums.LineEquipmentType.MX4
            || this.model.equipment[id].type === apsEnums.LineEquipmentType.Mcal
            || this.model.equipment[id].type === apsEnums.LineEquipmentType.Multi
            || this.model.equipment[id].type === apsEnums.LineEquipmentType.FlexBC
            || this.model.equipment[id].type === apsEnums.LineEquipmentType.FlexM
            || this.model.equipment[id].type === apsEnums.LineEquipmentType.WBF
          ) {
            this.hasCavities = true;
            break;
          }
        }
      });
  }

  cavityCorrelationPromise(): IPromise<void> {
    this.reportDate = getReportDate(this.model.shopConfig, this.countsInterval);
    return this.countsService.getCavityCorrelation(this.shop.id, this.reportDate.Start, this.reportDate.End)
      .then((cavities) => {
        this.cavities = cavities;
      });
  }

  startInterval(): IPromise<void> {
    return this.$q((resolve) => {
      this.destroyInterval();
      this.interval = new Interval(this.update.bind(this), this.$interval, 5 * 60 * 1000); // 5 minutes
      this.interval.start();
      resolve();
    });
  }

  registerDestroy(): void {
    this.$scope.$on('$destroy', () => {
      this.destroyInterval();
    });
  }

  destroyInterval(): void {
    if (this.interval != null) {
      this.interval.destroy();
      this.interval = null;
    }
  }

  update() {
    this.reportDate = getReportDate(this.model.shopConfig, this.countsInterval);
    const promise = this.countsService.getCavityCorrelation(
      this.shop.id,
      this.reportDate.Start,
      this.reportDate.End)
      .then((cavities) => {
        this.cavities = cavities;
      });
    this.loaderService.loadingPromise(promise);
  }

  constructor(
    $state: IStateService,
    $interval: angular.IIntervalService,
    $stateParams: StateParams,
    $q: IQService,
    $scope: IScope,
    countsService: CountsService,
    loaderService: LoaderService,
    authDataService: AuthDataService,
    uiUtilityService: UIUtilityService,
    navigationService: NavigationService,
  ) {
    this.$state = $state;
    this.$interval = $interval;
    this.$stateParams = $stateParams;
    this.$q = $q;
    this.$scope = $scope;
    this.authDataService = authDataService;
    this.userId = $stateParams.userId;
    this.countDisplayIntervalOptions = uiUtilityService.getListOptionsFromEnum(
      apsDisplayEnums.CountDisplayInterval,
      null, null, o => o);
    this.countsInterval = authDataService.getCountInterval();
    this.countsService = countsService;
    this.loaderService = loaderService;
    this.canDisableLine = authDataService.isPlantOrAPSIOAdminForCurrentPlant();
    this.navigationService = navigationService;

    this.barClick = (summary: apsViewModels.CavityCountSummary) => {
      const reportStateParams: CavityCorrelationReportParams = {
        plantId: this.$stateParams.plantId,
        shopId: this.$stateParams.shopId,
        userId: this.$stateParams.userId,
        reportPlantId: this.$stateParams.plantId,
        reportShopId: this.$stateParams.shopId,
        startDate: this.reportDate.Start.toISOString(),
        endDate: this.reportDate.End ? this.reportDate.End.toISOString() : undefined,
        autoRun: true,
        cavity: summary.cavity
      };
      this.$state.go(States.CAVITY_CORRELATION, reportStateParams);
    };

    this.registerDestroy();
    this.loaderService.setAppLoading(true);
    this.plantShopsPromise().then(() => {
      this.countsPromise().then(() => {
        this.cavityCorrelationPromise().then(() => {
          this.startInterval().then(() => {
            this.loaderService.setAppLoading(false);
          });
        });
      });
    });
  }
}

export default angular.module('aps.controller.countsCavityCorrelation', requires)
  .config(countsConfig)
  .controller('CountsCavityCorrelationCtrl', CountsCavityCorrelationCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/counts/ccc.controller.ts